import React, { useState, useEffect } from "react";
import { Button, Row, Col, Input } from "antd";
import { useTranslation } from "react-i18next";
import { Filters } from "../../../components/Drawer/Articles/Filters";
import InvestmentFondsTable from "../../../components/Tables/InvestmentFonds";

import "../../../public/sass/pages/_articles.scss";
import Api from "../../../api";
import { toastNotification } from "../../../utils/toastNotification";
import { GeneralFormTitle } from "../../../components/GeneralFormTitle";
import EditPlacedFond from "../../../components/Drawer/PlacedFonds/EditPlacedFond";
import CreatePlacedFond from "../../../components/Drawer/PlacedFonds/CreatePlacedFond";
import PlacedFondsTable from "../../../components/Tables/PlacedFonds";

const PlacedFondsContainer = () => {
  const [t, i18n] = useTranslation();
  const [isVisibleCreate, setVisibleCreate] = useState(false);
  const [modalState, setModal] = useState({ id: "", mode: "", isOpen: false });
  const [loading, setLoading] = useState(true);
  const [fonds, setFonds] = useState([]);
  const [editData, setData] = useState([]);
  const [generalInfo, setGeneralInfo] = useState([]);

  const toggleDrawer = () => setVisibleCreate(!isVisibleCreate);

  const handleModal = (mode, isOpen, id) => {
    setModal({
      ...modalState,
      ["mode"]: mode,
      ["isOpen"]: isOpen,
      ["id"]: id,
    });
  };

  const handleGetAllFonds = () => {
    Api("generals/type/placed-fonds", "GET", null)
      .then((data) => {
        if (!data) {
          toastNotification("info", "Please add general information first!");
          setLoading(false);
        } else {
          setGeneralInfo(data);
          setLoading(false);
        }
      })
      .catch(() => setLoading(false));

    Api("fonds/type/placed", "GET", null)
      .then((data) => {
        setFonds(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    handleGetAllFonds();
  }, []);

  const getFondById = (id) => {
    setLoading(true);
    Api("fonds/" + id, "GET", null)
      .then((data) => {
        setData(data);
        handleModal("edit", true, id);
        setLoading(false);
      })
      .catch((err) => {
        toastNotification("error", err.error || "Something went wrong!");
        setLoading(false);
      });
  };

  const deleteFond = (id) => {
    if (!id) return message.error("Id is missing!");
    Api("fonds/" + id, "DELETE", null)
      .then(() => {
        toastNotification("success", "Fond was successfully deleted");
        handleGetAllFonds();
      })
      .catch(() => toastNotification("error", "Error while deleting fond"));
  };

  const handleSubmitGeneralForm = (values) => {
    if (!generalInfo.length && generalInfo.type !== "placed-fonds") {
      values.type = "placed-fonds";
      Api("generals/", "POST", values)
        .then((data) => {
          setLoading(false);
          setGeneralInfo(data);
          setVisibleCreate(true);
        })
        .catch((err) => {
          toastNotification("error", err.error || "Something went wrong!");
          setLoading(false);
        });
    } else {
      Api("generals/" + generalInfo.id, "PATCH", values)
        .then((data) => {
          setLoading(false);
          setGeneralInfo(data);
        })
        .catch((err) => {
          toastNotification("error", err.error || "Something went wrong!");
          setLoading(false);
        });
    }
  };

  return (
    <div className="articles-container">
      <div className="header">
        <Filters />
        {/* <Button className="button" onClick={() => handleModal("create", true)}>
          {t("add_placed_fond")}
        </Button> */}
      </div>
      <CreatePlacedFond
        onClose={handleModal}
        isVisible={modalState.mode == "create" && modalState.isOpen}
        handleGetAllFonds={handleGetAllFonds}
        fonds={fonds}
      />
      <EditPlacedFond
        data={editData}
        id={modalState.id}
        isVisible={modalState.mode == "edit" && modalState.isOpen}
        handleGetAllFonds={handleGetAllFonds}
        onClose={handleModal}
        fonds={fonds}
      />
      <GeneralFormTitle
        handleSubmitGeneralForm={handleSubmitGeneralForm}
        generalInfo={generalInfo}
      />
      <PlacedFondsTable
        getFondById={getFondById}
        fonds={fonds}
        loading={loading}
        deleteFond={deleteFond}
      />
    </div>
  );
};
export default PlacedFondsContainer;
